import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ConsentCheckboxes = ({
  part1Checked,
  part2Checked,
  onPart1Change,
  onPart2Change,
  marketingChecked,
  onMarketingChange,
  showMarketing = false,
  idPrefix = 'consent',
  className = '',
  onLinkClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`space-y-3 text-left ${className}`}>
      <label
        htmlFor={`${idPrefix}-part1`}
        className="flex items-start gap-3 cursor-pointer"
      >
        <input
          id={`${idPrefix}-part1`}
          type="checkbox"
          checked={part1Checked}
          onChange={(e) => onPart1Change(e.target.checked)}
          className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-2 border-border text-primary focus:ring-2 focus:ring-primary/40 accent-primary"
        />
        <span className="text-xs sm:text-sm leading-relaxed text-foreground">
          I am 18 years of age or older and agree to the{' '}
          <Link
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onLinkClick}
            className="text-primary hover:underline font-medium"
          >
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onLinkClick}
            className="text-primary hover:underline font-medium"
          >
            Privacy Policy
          </Link>
          . I understand that All Animal App uses AI features that generate
          automated content for informational purposes only.
        </span>
      </label>

      <label
        htmlFor={`${idPrefix}-part2`}
        className="flex items-start gap-3 cursor-pointer"
      >
        <input
          id={`${idPrefix}-part2`}
          type="checkbox"
          checked={part2Checked}
          onChange={(e) => onPart2Change(e.target.checked)}
          className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-2 border-border text-primary focus:ring-2 focus:ring-primary/40 accent-primary"
        />
        <span className="text-xs sm:text-sm leading-relaxed text-foreground">
          I consent to the processing of my inputs by All Animal App and its AI
          processor Google LLC, in the United States and applicable
          jurisdictions, to provide AI-generated features as described in the{' '}
          <Link
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onLinkClick}
            className="text-primary hover:underline font-medium"
          >
            Privacy Policy
          </Link>
          .
        </span>
      </label>

      {showMarketing && (
        <label
          htmlFor={`${idPrefix}-marketing`}
          className="flex items-start gap-3 cursor-pointer"
        >
          <input
            id={`${idPrefix}-marketing`}
            type="checkbox"
            checked={!!marketingChecked}
            onChange={(e) => onMarketingChange?.(e.target.checked)}
            className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-2 border-border text-primary focus:ring-2 focus:ring-primary/40 accent-primary"
          />
          <span className="text-xs sm:text-sm leading-relaxed text-foreground">
            {t(
              'signup_marketing_optin_label',
              'Send me occasional product updates, tips, and community news from All Animal App. You can change this anytime in your email preferences.'
            )}
          </span>
        </label>
      )}
    </div>
  );
};

export default ConsentCheckboxes;
